import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchUserCircles, isCircleVisible } from "@core/features/circle";
import { usePlatformStore } from "@platform/store";
import { useCurrentMeeting } from "@platform/hooks/useCurrentMeeting";
import { isMeetingJoinableNow } from "@platform/utils/isMeetingJoinableNow";
import { SchedulingCohortMessageContainer } from "@platform/features/programScheduling";
import { CohortDashboardBanner } from "./CohortDashboardBanner";

export function CohortDashboardBannerContainer() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const programId = id ? Number(id) : undefined;
  const user = usePlatformStore((s) => s.user);

  const { data: circlesData } = useFetchUserCircles({ user });
  const visibleCircle = useMemo(
    () => (circlesData?.circles ?? []).find(isCircleVisible) ?? null,
    [circlesData?.circles]
  );

  const { currentMeeting } = useCurrentMeeting();
  const isJoinable = isMeetingJoinableNow(currentMeeting);

  if (!visibleCircle || !programId) {
    return null;
  }

  return (
    <CohortDashboardBanner
      message={<SchedulingCohortMessageContainer />}
      isJoinable={isJoinable}
      onScheduleClick={() => navigate(`/program/${programId}/schedule`)}
      onCohortClick={() => navigate(`/program/${programId}/cohort`)}
      onJoinClick={() => navigate("/video")}
    />
  );
}

export default CohortDashboardBannerContainer;
